import type { PropsWithChildren } from 'react';
import { cn } from '@/shared/utils/styling';
import { cva } from 'class-variance-authority';

type Props = {
  size?: 'small' | 'medium';
  className?: string;
};

const errorTextVariants = cva('text-destructive text-left', {
  variants: {
    size: {
      small: 'p5 py-0',
      medium: 'p3 py-[1.2rem]',
    },
  },
});

const ErrorText = ({
  size = 'medium',
  className,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <p className={cn(errorTextVariants({ size }), className)}>{children}</p>
  );
};

export { ErrorText };
